import React from 'react';

const PlayIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="28" cy="28" r="27" stroke="white" strokeWidth="2" />
    <path d="M41 28.5L20.75 40.1913L20.75 16.8087L41 28.5Z" fill="white" />
  </svg>
);

PlayIcon.displayName = 'PlayIcon';
export default PlayIcon;
